import { CmsWebsiteBM, ICmsWebsite } from './cms.types.js'
import { ICustomer } from './customer.types.js'
import { IWebsite, WebsiteBM } from './website.types.js'

export interface WebsiteBase {
  type: WebsiteType
  name: string
  viewName: string
  netlifySiteId?: string
  atlasAnalyticsReporterId?: string
  /**
   * Netlify URL
   */
  url?: string
  customDomain?: string
  customer: ICustomer | string
  features: string[]
  eCommerceConfigId?: string
}

export enum WebsiteType {
  ATLAS_WEBSITE = 'ATLAS_WEBSITE',
  CMS_WEBSITE = 'CMS_WEBSITE',
}

export interface WebsiteBaseBM extends WebsiteBase {
  _id: string
}

export type AnyWebsite = ICmsWebsite | IWebsite

export type AnyWebsiteBM = CmsWebsiteBM | WebsiteBM
